import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useEffect,
} from "react"
import lottie from "lottie-web"
import { View } from "react-native"
import { type WebLottieViewProps } from "@/types/animationTypes"

export const BFLottieView = forwardRef<any, WebLottieViewProps>(
  (
    {
      source,
      style,
      speed = 1,
      loop = false,
      autoplay = false,
      renderer = "canvas",
      onComplete,
      direction = 1,
      ...rest
    },
    ref
  ) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const animationRef = useRef<any>(null)

    useImperativeHandle(ref, () => ({
      play: (startFrame?: number, endFrame?: number) => {
        if (animationRef.current) {
          if (startFrame !== undefined) {
            animationRef.current.goToAndPlay(startFrame, true)
          } else {
            animationRef.current.play()
          }
        }
      },
      pause: () => {
        animationRef.current?.pause()
      },
      stop: () => {
        animationRef.current?.stop()
      },
    }))

    useEffect(() => {
      if (containerRef.current) {
        animationRef.current = lottie.loadAnimation({
          container: containerRef.current,
          renderer,
          loop,
          autoplay,
          animationData: source,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid meet",
          },
        })

        animationRef.current.setSpeed(speed)
        animationRef.current.setDirection(direction)

        if (onComplete) {
          animationRef.current.addEventListener("complete", onComplete)
        }

        return () => {
          animationRef.current?.destroy()
        }
      }
    }, [source, loop, speed, autoplay, renderer, direction, onComplete])

    return (
      <View style={style}>
        <div
          ref={containerRef}
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      </View>
    )
  }
)
